import React from "react";
import { Tee } from "./types";

interface Props {
  tee: Tee | undefined | null;
  // Diameter in px. Default 14 — small enough to sit beside a name in a
  // scorecard cell, big enough to read at a glance.
  size?: number;
  className?: string;
}

// Visual tee indicator. Single-colour tees render as a filled circle.
// Combo tees (Silver/Copper, Copper/Pewter, etc.) render as a 50/50
// vertical split using a linear-gradient stop, which gives a clean
// half-and-half appearance without needing SVG.
export default function TeeDot({ tee, size = 14, className }: Props) {
  if (!tee) return null;
  const colors =
    tee.colors && tee.colors.length > 0 ? tee.colors : [tee.color];
  const style: React.CSSProperties = { width: size, height: size };
  if (colors.length === 1) {
    style.background = colors[0];
  } else {
    style.background = `linear-gradient(90deg, ${colors[0]} 0 50%, ${colors[1]} 50% 100%)`;
  }
  return (
    <span
      className={`cg-tee-dot${className ? ` ${className}` : ""}`}
      style={style}
      aria-label={`${tee.name} tee`}
    />
  );
}
